import {
  Autocomplete as MuiAutocomplete,
  TextField,
  useMediaQuery,
} from '@mui/material'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'

type AutocompleteType = {
  options: { value: string; label: string }[]
  onChange: (newUnit: { value: string; label: string } | null) => void
  onClear: () => void
  value: { value: string; label: string } | null
  label: string
  name: string
  ml?: string
  placeholder?: string
  error?: string
}

export const Autocomplete = ({
  options,
  onChange,
  onClear,
  value,
  name,
  label,
  ml,
  placeholder,
  error,
}: AutocompleteType) => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <MuiAutocomplete
      disablePortal
      noOptionsText={t('noOptionsAutoComplete')}
      options={options ?? []}
      onChange={(e, value, reason, details) => {
        if (reason === 'selectOption') {
          if (details) {
            const newUnit =
              options?.find(
                (unit: { label: string; value: string }) =>
                  unit.value === details.option.value
              ) || null
            onChange(newUnit)
          }
        }
        if (reason === 'clear') {
          onClear()
        }
      }}
      sx={{
        '&.MuiAutocomplete-root': {
          flex: 1,
        },
        '&.MuiAutocomplete-root .MuiFilledInput-root': {
          paddingTop: '2px',
        },
        '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
          minWidth: '50px',
        },
        marginLeft: isMobile ? 0 : ml || 0,
        marginBottom: theme.spacing(0.5),
      }}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.value}>
            {option.label}
          </li>
        )
      }}
      value={value || null}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.label ?? ''}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          label={t(label)}
          error={Boolean(error)}
          InputLabelProps={{
            shrink: true,
            sx: { top: '-6px', left: '-4px' },
          }}
          placeholder={placeholder}
          helperText={error}
          variant='filled'
          sx={{
            '& .MuiFilledInput-root': {
              paddingTop: '0px',
            },
          }}
        />
      )}
      id={name}
    />
  )
}
